export default __webpack_public_path__ + "../staticImages/sprite-hermeslogo-2x.png";